import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SpinnerService {
    private _isLoading = new BehaviorSubject<boolean>(false);
    private _runningProcesses: BehaviorSubject<Map<string, string>> = new BehaviorSubject(new Map());

    addProcess(key: string, message = 'Loading...'): void {
        const runningProcesses = this._runningProcesses.getValue();
        runningProcesses.set(key, message);
        this._runningProcesses.next(runningProcesses);
        this._isLoading.next(true);
    }

    completeProcess(key: string): void {
        const value = this._runningProcesses.getValue();
        value.delete(key);
        this._runningProcesses.next(value);
        this._isLoading.next(value.size > 0);
    }

    clearProcesses(): void {
        this._runningProcesses.next(new Map());
        this._isLoading.next(false);
    }

    isLoading(): Observable<boolean> {
        return this._isLoading.asObservable();
    }

    getMessages(): Observable<string[]> {
        return this._runningProcesses.pipe(map(runningProcesses => Array.from(runningProcesses.values())));
    }
}
